import Paragraph from '@/shared/Paragraph/ui/Paragraph';

export const getVContent = (
    title: string,
    data: Record<string, string>,
    key: string,
    id: string
): { title: string; id: string; content: React.ReactNode } | undefined => {
    const content = data[key];

    if (content) {
        return {
            title,
            id,
            content: <Paragraph id={`activity_${key}`} as="div" innerHtml={content} />,
        };
    }

    return undefined;
};
